import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import GModal from 'tennders-market/common/components/element/GModal'
import { StateType } from 'tennders-common/types/StateType'
import { dispatchInformativeModal } from 'tennders-common/stores/modal/action'
import useTranslation from 'next-translate/useTranslation'
import { useRouter } from 'next/router'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleCheck } from '@fortawesome/free-solid-svg-icons'

const InformativeModal = (props) => {
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const router = useRouter()
  const modal = useSelector((state:StateType) => state.modal.informativeModal)
  const close = () => {
    dispatch(dispatchInformativeModal(null))
  }
  useEffect(() => {
    if (modal) {
      setTimeout(() => {
        close()
        router.push(`/company-detail/${modal?.id}`)
      },
      3000)
    }
  }, [modal])
  return (
    <GModal
      size={300}
      isOpen={!!modal}
      {...props}
    >
      <div className="tennders-modal-body text-center w-100">
        <h3 className="bold">
          <FontAwesomeIcon icon={faCircleCheck} size="lg" className="mr-4 color-green" />
          {modal?.isQc ? t('modal:sentForQC') : t('modal:temporaryProfileCreated')}
        </h3>
        {!modal?.isQc && <p className=" action-btn mr-4">{t('modal:completeProfile')}</p>}
      </div>
    </GModal>
  )
}

export default InformativeModal
